<template>
  <div>
    <vue-headful title="Credimóvil | Comprar un auto "/>
    <menu-component></menu-component>
    <!-- Banner Area -->
    <section class="banner_area banner_area_car">
      <div class="container">
    		<h6></h6>
    	</div>
    </section>

    <!-- search Area -->
    <section class=" content-card">
    	<div class="container">
        <div class="features_b">
          <br>
          <div class="row">
            <div class="col-auto mr-auto">
              <h3>Comparador de autos</h3>
            </div>
          </div>
        </div>
        <br>
        <div class="row">
          <div class="col-lg-3 col-mb-3">
            <button class="theme_btn btn btn-block mb-3" v-on:click="doFilter()">Filtrar</button>
            <!-- <div class="col-auto mr-auto ">
              <h5 class="bold">Filtrar</h5>
            </div> -->
            <div class="filter-input">
              <input type="text" class="post_input" placeholder="Palabras clave" style="width: 90%; border: none;"
                id="precio" name="precio" v-model="form.filter" v-on:keyup.enter="doFilter()">
              <i class="fa fa-search" aria-hidden="true" style="cursor: pointer;" v-on:click="doFilter()"></i>
            </div>
            <div id="accordion">
            <div class="card">
              <div class="card-header pb-3 pt-3 pr-2 pl-2" id="heading1">
                <h5 class="mb-0">
                  <button class="item-collapse btn btn-link btn-block collapsed ml-0 pl-0 pr-0" data-toggle="collapse" data-target="#collapse1" aria-expanded="false" aria-controls="collapse3">
                    <div class="display_button p-2 pr-0"><h5>Modelo</h5> <i class="fa fa-plus"></i></div>  
                  </button>
                </h5>
              </div>
              <div id="collapse1" class="collapse" aria-labelledby="heading1" data-parent="#accordion">
                <div class="card-body">
                  <div  v-for="model in models" v-bind:key="model">
                    <div class="custom-control custom-radio custom-control-inline">
                      <input type="radio" class="custom-control-input" name="models" :id="'model' + model" :value="model" v-model="form.selectedModel">
                      <label class="custom-control-label" :for="'model' + model">{{model}}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card" >
              <div class="card-header pb-3 pt-3 pr-2 pl-2" id="heading2" >
                <h5 class="mb-0">
                  <button class="item-collapse btn btn-link btn-block collapsed ml-0 pl-0 pr-0" data-toggle="collapse" data-target="#collapse2" aria-expanded="false" aria-controls="collapseTwo" :disabled="form.selectedModel == ''">
                    <div class="display_button p-2 pr-0"><h5>Marca</h5> <i class="fa fa-plus"></i></div> 
                  </button>
                </h5>
              </div>
              <div id="collapse2" class="collapse" aria-labelledby="heading2" data-parent="#accordion" >
                <div class="card-body">
                  <div v-for="brand in brands" v-bind:key="brand">
                    <div class="custom-control custom-radio custom-control-inline">
                      <input type="radio" class="custom-control-input" name="brands" :id="'brand' + brand" :value="brand" v-model="form.selectedBrand">
                      <label class="custom-control-label" :for="'brand' + brand">{{brand}}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-header pb-3 pt-3 pr-2 pl-2" id="heading3">
                <h5 class="mb-0">
                  <button class="item-collapse btn btn-link btn-block collapsed ml-0 pl-0 pr-0" data-toggle="collapse" data-target="#collapse3" aria-expanded="false" aria-controls="collapse3" :disabled="form.selectedBrand == ''">
                    <div class="display_button p-2 pr-0"><h5>Versión</h5> <i class="fa fa-plus"></i></div> 
                  </button>
                </h5>
              </div>
              <div id="collapse3" class="collapse" aria-labelledby="heading3" data-parent="#accordion">
                <div class="card-body">
                  <div v-for="version in versions" v-bind:key="version">
                    <div class="custom-control custom-radio custom-control-inline">
                      <input type="radio" class="custom-control-input" name="versions" :id="'version' + version" :value="version" v-model="form.selectedVersion">
                      <label class="custom-control-label" :for="'version' + version">{{version}}</label>
                    </div>
                    <!-- <div class=" mb-2">
                      <input type="checkbox" name="versions" :id="'filledInCheckbox' + version" :value="version" v-model="form.selectedVersion">
                      <label :for="'filledInCheckbox' + version">{{ version }}</label>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="card">
              <div class="card-header pb-3 pt-3 pr-2 pl-2" id="heading4">
                <h5 class="mb-0">
                  <button class="item-collapse btn btn-link btn-block collapsed ml-0 pl-0 pr-0" data-toggle="collapse" data-target="#collapse4" aria-expanded="false" aria-controls="collapse4">
                    <div class="display_button p-2 pr-0"><h5>Vendedor</h5> <i class="fa fa-plus"></i></div> 
                  </button>
                </h5>
              </div>
              <div id="collapse4" class="collapse" aria-labelledby="heading4" data-parent="#accordion">
                <div class="card-body">
                  <div class="custom-control custom-radio ">
                      <input type="radio" class="custom-control-input" name="sellers" id="seller1" value="Seminuevos 1" v-model="form.sellers">
                      <label class="custom-control-label" for="seller1">Seminuevos 1</label>
                  </div>
                  <div class="custom-control custom-radio">
                      <input type="radio" class="custom-control-input" name="sellers" id="seller2" value="Seminuevos 2" v-model="form.sellers">
                      <label class="custom-control-label" for="seller2">Seminuevos 2</label>
                  </div>
                  <div class="custom-control custom-radio">
                      <input type="radio" class="custom-control-input" name="sellers" id="seller3" value="Seminuevos 3" v-model="form.sellers">
                      <label class="custom-control-label" for="seller3">Seminuevos 3</label>
                  </div>
                  <div class="custom-control custom-radio">
                      <input type="radio" class="custom-control-input" name="sellers" id="seller4" value="Seminuevos 4" v-model="form.sellers">
                      <label class="custom-control-label" for="seller4">Seminuevos 4</label>
                  </div>
                </div>
              </div>
            </div> -->
            <div class="card">
              <div class="card-header pb-3 pt-3 pr-2 pl-2" id="heading5">
                <div class="row">
                  <div class="col-lg-12 text-center">
                    <input type="text" id="price_range" readonly style="border:0; color: gray; font-size: 16px;background: #f7f7f7; width: 150px">
                  </div>
                  <div class="col-lg-3">
                    <h5 style="font-weight: 600;">$</h5>
                  </div>
                  <div class="col-lg-8 pt-2">
                   <div id="slider_price"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-header pb-3 pt-3 pr-2 pl-2" id="heading6">
                <div class="row">
                  <div class="col-lg-12 text-center">
                    <input type="text" id="km_range" readonly style="border:0; color: gray; font-size: 16px;background: #f7f7f7; width: 150px">
                  </div>
                  <div class="col-lg-3">
                    <h5 style="font-weight: 600;">Km</h5>
                  </div>
                  <div class="col-lg-8 pt-2">
                   <div id="slider_km"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-header pb-3 pt-3 pr-2 pl-2" id="heading8">
                <h5 class="mb-0">
                  <button class="item-collapse btn btn-link collapsed btn-block ml-0 pl-0 pr-0" data-toggle="collapse" data-target="#collapse8" aria-expanded="false" aria-controls="collapse8">
                    <div class="display_button p-2 pr-0"><h5>Transmisión</h5> <i class="fa fa-plus"></i></div> 
                  </button>
                </h5>
              </div>
              <div id="collapse8" class="collapse" aria-labelledby="heading8" data-parent="#accordion">
                <div class="card-body">
                  <div class="custom-control custom-radio">
                      <input type="radio" class="custom-control-input" name="transmission" id="transmission1" value="Manual" v-model="form.transmission">
                      <label class="custom-control-label" for="transmission1">Manual</label>
                  </div>
                  <div class="custom-control custom-radio">
                      <input type="radio" class="custom-control-input" name="transmission" id="transmission2" value="Automática" v-model="form.transmission">
                      <label class="custom-control-label" for="transmission2">Automática</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-header pb-3 pt-3 pr-2 pl-2" id="heading9">
                <h5 class="mb-0">
                  <button class="item-collapse btn btn-link collapsed btn-block ml-0 pl-0 pr-0" data-toggle="collapse" data-target="#collapse9" aria-expanded="false" aria-controls="collapse9">
                    <div class="display_button p-2 pr-0"><h5>Estados</h5> <i class="fa fa-plus"></i></div> 
                  </button>
                </h5>
              </div>
              <div id="collapse9" class="collapse" aria-labelledby="heading9" data-parent="#accordion">
                <div class="card-body">
                  <div v-for="state in states" v-bind:key="state">
                    <div class="custom-control custom-radio custom-control-inline">
                      <input type="radio" class="custom-control-input" name="states" :id="'state' + state" :value="state" v-model="form.state">
                      <label class="custom-control-label" :for="'state' + state">{{state}}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-header pb-3 pt-3 pr-2 pl-2" id="heading10">
                <h5 class="mb-0">
                  <button class="item-collapse btn btn-link collapsed btn-block ml-0 pl-0 pr-0" data-toggle="collapse" data-target="#collapse11" aria-expanded="false" aria-controls="collapse11" :disabled="form.state == ''">
                    <div class="display_button p-2 pr-0"><h5>Ciudad</h5> <i class="fa fa-plus"></i></div>
                  </button>
                </h5>
              </div>
              <div id="collapse11" class="collapse" aria-labelledby="headingThree" data-parent="#accordion">
                <div class="card-body">
                  <div v-for="city in townships" v-bind:key="city">
                    <div class="custom-control custom-radio custom-control-inline">
                      <input type="radio" class="custom-control-input" name="cities" :id="'city' + city" :value="city" v-model="form.city">
                      <label class="custom-control-label" :for="'city' + city">{{city}}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-header pb-3 pt-3 pr-2 pl-2" id="headingThree">
                <h5 class="mb-0">
                  <button class="item-collapse btn btn-link collapsed btn-block ml-0 pl-0 pr-0" data-toggle="collapse" data-target="#collapse12" aria-expanded="false" aria-controls="collapse12">
                    <div class="display_button p-2 pr-0"><h5>Condición</h5> <i class="fa fa-plus"></i></div>
                  </button>
                </h5>
              </div>
              <div id="collapse12" class="collapse" aria-labelledby="headingThree" data-parent="#accordion">
                <div class="card-body">
                  <div class="custom-control custom-radio">
                      <input type="radio" class="custom-control-input" name="condition" id="condition1" value="Usado" v-model="form.condition">
                      <label class="custom-control-label" for="condition1">Usado</label>
                  </div>
                  <div class="custom-control custom-radio">
                      <input type="radio" class="custom-control-input" name="condition" id="condition2" value="Seminuevo" v-model="form.condition">
                      <label class="custom-control-label" for="condition2">Seminuevo</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-header pb-3 pt-3 pr-2 pl-2" id="headingThree">
                <h5 class="mb-0">
                  <button class="item-collapse btn btn-link collapsed btn-block ml-0 pl-0 pr-0" data-toggle="collapse" data-target="#collapse13" aria-expanded="false" aria-controls="collapse13">
                    <div class="display_button p-2 pr-0"><h5>Combustible</h5> <i class="fa fa-plus"></i></div>
                  </button>
                </h5>
              </div>
              <div id="collapse13" class="collapse" aria-labelledby="headingThree" data-parent="#accordion">
                <div class="card-body">
                  <div class="custom-control custom-radio">
                      <input type="radio" class="custom-control-input" name="fuel" id="fuel1" value="Gasolina" v-model="form.fuel">
                      <label class="custom-control-label" for="fuel1">Gasolina</label>
                  </div>
                  <div class="custom-control custom-radio">
                      <input type="radio" class="custom-control-input" name="fuel" id="fuel2" value="Eléctrico" v-model="form.fuel">
                      <label class="custom-control-label" for="fuel2">Eléctrico</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-header pb-3 pt-3 pr-2 pl-2" id="headingThree">
                <h5 class="mb-0">
                  <button class="item-collapse btn btn-link collapsed btn-block ml-0 pl-0 pr-0" data-toggle="collapse" data-target="#collapse14" aria-expanded="false" aria-controls="collapse14">
                    <div class="display_button p-2 pr-0"><h5>Color</h5> <i class="fa fa-plus"></i></div>
                  </button>
                </h5>
              </div>
              <div id="collapse14" class="collapse" aria-labelledby="headingThree" data-parent="#accordion">
                <div class="card-body pb-3 pt-3 pr-2 pl-2">
                  <div v-for="color in colors" v-bind:key="color">
                    <div class="custom-control custom-radio">
                      <input type="radio" class="custom-control-input" name="colors" :id="'color' + color" :value="color" v-model="form.color">
                      <label class="custom-control-label" :for="'color' + color">{{color}}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-header pb-3 pt-3 pr-2 pl-2" id="headingThree">
                <h5 class="mb-0">
                  <button class="item-collapse btn btn-link collapsed btn-block ml-0 pl-0 pr-0" data-toggle="collapse" data-target="#collapse16" aria-expanded="false" aria-controls="collapse16">
                    <div class="display_button p-2 pr-0"><h5>Cilindros</h5> <i class="fa fa-plus"></i></div>
                  </button>
                </h5>
              </div>
              <div id="collapse16" class="collapse" aria-labelledby="headingThree" data-parent="#accordion">
                <div class="card-body">
                  <div v-for="cylinder in cylinders" v-bind:key="cylinder">
                    <div class="custom-control custom-radio">
                      <input type="radio" class="custom-control-input" name="cylinders" :id="'cylinder' + cylinder" :value="cylinder" v-model="form.cylinders">
                      <label class="custom-control-label" :for="'cylinder' + cylinder">{{ cylinder }}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <button class="theme_btn btn btn-block" v-on:click="doFilter()">Filtrar</button> -->
          </div>
          <div class="col-lg-9 col-md-12">
            <div class="row">
              <div class="col-12" v-if="data.length == 0" style="text-align: center;font-size: 30px;font-weight: 600;color: #2759ab;">
                No hay vehículos con los filtros seleccionados
              </div>
              <div class="col-lg-4 col-md-6" v-for="item in data" v-bind:key="item.id">
                <a class="text-dark" v-on:click="redirect(item)" style="cursor: pointer;">
                  <div class="card" style="width: 18rem;">
                    <img class="card-img-top" :src="filterImage(item.vehicle.images)" alt="Card image cap" style="object-fit: cover; height: 180px;">
                    <div class="card-body">
                      <h5>{{ item.vehicle.brand }} {{ item.vehicle.model }}</h5>
                      <div class="container">
                        <div class=" clearfix"> 
                          <span class="border border-secondary">{{ item.vehicle.year }}</span>
                          {{ item.vehicle.mileage }} kms
                        </div>
                      </div>
                      <div class="container">
                        <div class="row">
                          <div class="col-lg-7">
                            <p class="card-text letters-colored">
                              <strong>$ {{ formatPrice(item.vehicle.price) }}</strong>
                            </p>
                          </div>
                          <div class="col-lg-2">
                            <img height="30px" src="images/logo@2x.png" alt="">
                          </div>
                          <div class="col-lg-3"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
          <div class="col-lg-9 offset-lg-3 col-md-12 pt-5 mt-5">
            <sliding-pagination class="c-sliding-pagination"
              :current="currentPage"
              :total="totalPages"
              @page-change="pageChangeHandler"
            ></sliding-pagination>
          </div>
        </div>
    	</div>
    </section>
    <!-- search Area -->
  </div>
</template>

<script>
  import { required, minLength, between, minValue, maxValue } from 'vuelidate/lib/validators';
  import statesAndTownship from '../assets/estados-municipios.json';
  import SlidingPagination from 'vue-sliding-pagination'


  var priceMin = 0;
  var priceMax = 300000;
  var kmMin = 0;
  var kmMax = 500000;

  export default {
    name: 'CarFilter',
    components: {
      SlidingPagination
    },
    data() {
      return {
        currentPage: 1,
        totalPages: 10,
        data: [],
        states: [],
        townships: [],
        modelFilter: '',
        brandFilter: '',
        keyWords: '',
        models: [],
        categories: [],
        brands: [],
        versions: [],
        descriptions: [],
        array : [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15],
        colors: [],
        cylinders: [3, 4, 5, 6, 8, 12],
        form: {
          selectedModel: '',
          selectedBrand: '',
          selectedVersion: '',
          // sellers: [],
          filter: '',
          vehiclePriceMin: 0,
          vehiclePriceMax: 0,
          vehicleKmMin: 0,
          vehicleKmMax: 0,
          transmission: '',
          state: '',
          city: '',
          condition: '',
          fuel: '',
          color: '',
          cylinders: 0
        },
        filters: {
          limit: 15,
          page: 1,
          brand: "",
          model: "",
          mileage_min: 0,
          mileage_max: 0,
          fuel: "",
          year: "",
          owners: "",
          condition: "",
          color:"",
          price_min: 0,
          price_max: 0,
          motor: "",
          cylinders : 0,
          transmission: "",
          passengers: 0,
          search: "",
        },
      }
    },
    validations() {
      return {
        form: {
          selectedModel: { required },
          selectedBrand: { required },
          selectedVersion: { required },
          vehiclePrice: { required, minValue: minValue(1) },
        },
      }
    },
    methods: {
      pageChangeHandler(selectedPage) {
        this.currentPage = selectedPage;
        this.filters.page = this.currentPage;
        this.getData(this.filters)
      },
      refreshSelects() {
        $( "#slider_price" ).slider({
          range: true,
          min: 0,
          max: 300000,
          values: [ 0, 300000 ],
          slide: function( event, ui ) {
            $( "#price_range" ).val( "$" + ui.values[ 0 ] + " - $" + ui.values[ 1 ] );
            priceMax = ui.values[ 1 ];
            priceMin = ui.values[ 0 ];
          }
        });
        $( "#price_range" ).val( "$" + $( "#slider_price" ).slider( "values", 0 ) + " - $" + $( "#slider_price" ).slider( "values", 1 ) );
        $( "#slider_km" ).slider({
          range: true,
          min: 0,
          max: 500000,
          values: [ 0, 500000 ],
          slide: function( event, ui ) {
            $( "#km_range" ).val(ui.values[ 0 ] + " - " + ui.values[ 1 ] );
            kmMax = ui.values[ 1 ];
            kmMin = ui.values[ 0 ];
          }
        });
        $( "#km_range" ).val( $( "#slider_km" ).slider( "values", 0 ) + " - " + $( "#slider_km" ).slider( "values", 1 ) );
        // this.assingFilters();
      },
      getStates() {
        this.states = Object.keys(statesAndTownship);
        setTimeout(() => {
            setTimeout(() => {
                $('input[name=states]:radio').on('change', () => {
                  // $('#city').val('');
                  this.form.city = '';
                  this.townships = [];
                  this.getTownships();
                });
            }, 100);
        }, 100);
      },
      getTownships() {
        this.townships = statesAndTownship[this.form.state];
        setTimeout(() => {
            setTimeout(() => {
                $('input[name=cities]:radio').on('change', () => {

                });
            }, 100);
        }, 100);
      },
      getModels() {
        
        this.$InsuranceService.getModels().then((result) => {
          this.models = result.data.model.slice(0,14);
          setTimeout(() => {
            this.refreshSelects();

            $('input[name=models]:radio').on('change', (event) => {
              // this.form.selectedModel = event.target.defaultValue;
              console.log(event)
              this.brands = [];
              this.versions = [];
              this.form.selectedBrand = '';
              this.form.selectedVersion = '';
              // if (!event.target.checked) {
              //   this.form.selectedBrand = [];
              //   this.form.selectedVersion = [];
              //   this.versions = [];
              // } 
              this.getBrands();

              setTimeout(() => {
                this.refreshSelects();
              }, 100);
            });
          }, 100);
        }, (err) => alert(err.msg));
      },
      getBrands() {
          const data = {
            model: this.form.selectedModel,
          };
          console.log(data);

          this.$InsuranceService.getBrands(data).then((result) => {
            this.brands = result.data.brand;
            

            setTimeout(() => {
              this.refreshSelects();

               $('input[name=brands]:radio').on('change', (event) => {
                this.versions = [];                

                this.getVersions();

                setTimeout(() => {
                  this.refreshSelects();
                }, 100);
              });
            }, 100);
          }, (err) => alert(err));

        // var index = 0;
        // this.form.selectedModel.forEach((model) =>  {
        //   const data = {
        //     model: model,
        //   };
        //   this.$InsuranceService.getBrands(data).then((result) => {
        //     result.data.brand.forEach((resBrand) => {
        //       if (this.brands.indexOf(resBrand) == -1) {
        //         this.brands.push(resBrand);
        //       }
        //     });
            
        //     if (index == 0) {
        //       setTimeout(() => {
        //         this.refreshSelects();
        //         $('input[name=brands]:checkbox').on('change', (event) => {
        //           this.versions = [];
        //           if (!event.target.checked) {
        //             this.form.selectedVersion = [];
        //           } 
        //           this.getVersions();
        //           setTimeout(() => {
        //             this.refreshSelects();
        //           }, 100);
        //         });
        //       }, 100);
        //     }
        //     index++;
        //   }, (err) => alert(err.msg));
        // });
        
      },
      getVersions() {
        if (this.form.selectedBrand != '') {
          const data = {
            model: this.form.selectedModel,
            brand: this.form.selectedBrand
          };

          this.$InsuranceService.getVersions(data).then((result) => {
            this.versions = result.data.version;

            setTimeout(() => {
              this.refreshSelects();

              $('input[name=versions]:radio').on('change', () => {

                setTimeout(() => {
                  this.refreshSelects();
                }, 100);
              });
            }, 100);
          }, (err) => alert(err));
        }

        // this.form.selectedModel.forEach((model) => {
        //   this.form.selectedBrand.forEach((brand) => {
        //     const data = {
        //       model,
        //       brand
        //     };
        //     this.$InsuranceService.getVersions(data).then((result) => {
        //       result.data.version.forEach((resVersion) => {
        //         if (this.versions.indexOf(resVersion) == -1) {
        //           this.versions.push(resVersion);
        //         }
        //       });
        //       setTimeout(() => {
        //         this.refreshSelects();

        //         $('input[name=versions]:checkbox').on('change', (event) => {
        //           console.log(this.form.selectedVersion);

        //           setTimeout(() => {
        //             this.refreshSelects();
        //           }, 100);
        //         });
        //       }, 100);
        //     }, (err) => console.log(err));
        //   })
        // });
      },
      redirect(item) {
        localStorage.setItem('vehicleId', item.vehicle.id);
        window.location = '/view-car';
      },
      filterSearch() {
        this.filters = {
          "search": this.form.filter
        }
        this.currentPage = 1;
        this.filters.page = 1;
        this.getData(this.filters);
      },
      doFilter() {
        this.form.vehiclePriceMin = priceMin;
        this.form.vehiclePriceMax = priceMax;
        this.form.vehicleKmMin = kmMin;
        this.form.vehicleKmMax = kmMax;
        
        this.filters = {
          "page": 1,
          "brand": this.form.selectedBrand,
          "model": this.form.selectedVersion,
          "mileage_min": Number(this.form.vehicleKmMin),
          "mileage_max": Number(this.form.vehicleKmMax),
          "fuel": this.form.fuel,
          "year": this.form.selectedModel,
          "condition": this.form.condition,
          "color": this.form.color,
          "price_min": Number(this.form.vehiclePriceMin),
          "price_max": Number(this.form.vehiclePriceMax),
          "cylinders" : Number(this.form.cylinders),
          "transmission": this.form.transmission,
          "search": this.form.filter
        }
        this.currentPage = 1;
        this.getData(this.filters);
      },
      assingFilters() {
        if (localStorage.getItem('model')) {
          this.form.selectedModel = localStorage.getItem('model');
          // $(`#model${localStorage.getItem('model')}`).attr("checked", true).click(); 
          // $(`#moodel${localStorage.getItem('model')}`).prop("checked", true).trigger("click");
          // $(`#model${localStrage.getItem('model')}`).click();
          this.getBrands();
          if (localStorage.getItem('brand')) {
            this.form.selectedBrand = localStorage.getItem('brand');

            this.getVersions();
            if (localStorage.getItem('version')) {
              this.form.selectedVersion = localStorage.getItem('version');
            }
          }
        }

        this.filters = {
          "year": this.form.selectedModel,
          "brand": this.form.selectedBrand,
          "model": this.form.selectedVersion,
          "limit": 15,
        };
      },
      getData(filters) {
        var newData = [];
        this.$VehicleService.getVehicles(filters).then((result) => {
          this.data = result.data;
          let noPages = Math.ceil(result.total / 15);
          this.totalPages = noPages;

          this.getColors(this.data);
        }, (err) => {
          alert(err.message);
        });
      },
      getColors(data) {
        data.forEach(item => {
          if (this.colors.indexOf(this.capitalizeOnlyFirst(item.vehicle.color)) == -1) {
            this.colors.push(this.capitalizeOnlyFirst(item.vehicle.color));
          }
        });
      },
      capitalizeOnlyFirst(string) {
        return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
      },
      filterImage(item) {
        if (item.length == 0 ) {
          return 'data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%22286%22%20height%3D%22180%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20286%20180%22%20preserveAspectRatio%3D%22none%22%3E%3Cdefs%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E%23holder_172c887333d%20text%20%7B%20fill%3Argba(255%2C255%2C255%2C.75)%3Bfont-weight%3Anormal%3Bfont-family%3AHelvetica%2C%20monospace%3Bfont-size%3A14pt%20%7D%20%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cg%20id%3D%22holder_172c887333d%22%3E%3Crect%20width%3D%22286%22%20height%3D%22180%22%20fill%3D%22%23777%22%3E%3C%2Frect%3E%3Cg%3E%3Ctext%20x%3D%2298.91666793823242%22%20y%3D%2295.7%22%3EImage%20cap%3C%2Ftext%3E%3C%2Fg%3E%3C%2Fg%3E%3C%2Fsvg%3E';
        } else {
          let flag = false;
          let url = '';

          for( let i = 0 ; i < item.length ; i++ ) {
            if (item[i].url.includes('.jpg') || item[i].url.includes('.jpeg') || item[i].url.includes('.png') ) {
              flag = true;
              url = item[i].url;
            }
          }

          if (flag) {
            return url;
          }
          return 'data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%22286%22%20height%3D%22180%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20286%20180%22%20preserveAspectRatio%3D%22none%22%3E%3Cdefs%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E%23holder_172c887333d%20text%20%7B%20fill%3Argba(255%2C255%2C255%2C.75)%3Bfont-weight%3Anormal%3Bfont-family%3AHelvetica%2C%20monospace%3Bfont-size%3A14pt%20%7D%20%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cg%20id%3D%22holder_172c887333d%22%3E%3Crect%20width%3D%22286%22%20height%3D%22180%22%20fill%3D%22%23777%22%3E%3C%2Frect%3E%3Cg%3E%3Ctext%20x%3D%2298.91666793823242%22%20y%3D%2295.7%22%3EImage%20cap%3C%2Ftext%3E%3C%2Fg%3E%3C%2Fg%3E%3C%2Fsvg%3E';
        }
      },
      formatPrice(value) {
          let num = (value/1).toFixed(2);
          return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      },
    },
    created() {
      this.getModels();
      this.getStates();
      // this.refreshSelects();
    },
    mounted() {
      this.assingFilters();
      this.getData(this.filters);
    }
  }
</script>

<style lang="scss">

  @import "~vue-sliding-pagination/dist/style/sliding-pagination";

  .ui-slider {
    height: 2px !important;
    position: relative;
    border: none !important;
    background: gray !important;
  }

  .ui-state-default, .ui-widget-content .ui-state-default, .ui-widget-header .ui-state-default {
      background: #f59019 !important;
      border-radius: 25px;
      outline: none;
      border: 2px solid #f59019 !important;
      position: absolute;
      top: -10px !important;
  }
  .ui-slider-horizontal .ui-slider-range {
      background: #f59019 !important;
      border: 1px solid #f59019 !important;
  }

  .page_btn {
    padding: 15px 25px;
    font-weight: 700;
    font-size: 20px;
    -webkit-box-shadow: 0px 10px 9px 0px rgba(0,0,0,0.5);
    -moz-box-shadow: 0px 10px 9px 0px rgba(0,0,0,0.5);
    box-shadow: 0px 10px 9px 0px rgba(0,0,0,0.5);
  }

  .c-sliding-pagination {
    text-align: center;
  }

  .c-sliding-pagination__list-element	{
    margin: 0.2rem;
    font-weight: 600;
    background: white;
    color: black;
    border-radius: 5px;
    &:hover {
      background: rgb(199, 199, 199);
    }
  }

  .c-sliding-pagination__list-element--active	{
    -webkit-box-shadow: 0px 10px 9px 0px rgba(0,0,0,0.5);
    -moz-box-shadow: 0px 10px 9px 0px rgba(0,0,0,0.5);
    box-shadow: 0px 10px 9px 0px rgba(0,0,0,0.5);
  }

  .c-sliding-pagination__page	{
    padding: 13px; 
  }

  .display_button {
    h5 {
      display: inline;
      float: left;
      font-weight: 600;
      margin-bottom: 10px;
      margin-left: 15px;
      font-size: 18px;
    }
    i {
      display: inline;
      float: right;
      font-size: 25px;
      color: #f59019;
    }
  }

  .error {
    border-color: red !important;
  }
  .post_input{
    position: relative;
    background: #fff;
    border: 1px solid #eaeaea;
    box-shadow: none;
    outline: none;
    font: 400 16px/40px "Source Sans Pro", sans-serif;
    padding: 0 28.5px;
    height: auto;
    border-radius: 5px;
    color: rgba(0, 0, 0, 0.6);
    // max-width: 150px;
  }

  .post_select {
    position: relative;
    background: #fff;
    border: 1px solid #eaeaea;
    box-shadow: none;
    outline: none;
    font: 400 16px/40px "Source Sans Pro", sans-serif;
    padding: 0 25px;
    height: auto;
    border-radius: 5px;
    color: rgba(0, 0, 0, 0.6);
    min-width: 150px;
    // background-color: transparent;
  }

  .buy-car-box {
  //   /* display: block;
  //   overflow: hidden; */
    background: #181a3c;
    color: white;
    // margin: 130px ;
    padding: 20px;
  }

  .content-card {
      padding-bottom: 100px;
      background-color: whitesmoke;
  }
  .border{
    padding: 2px;
  }
  .letters-colored {
    color: #f59019;
  }
  .bold{
    font-weight: bold;
  }
  .card {
    margin: 10px 5px;
    border: 0;
  }
  .filter-input {
    background-color: #ffffff;
    border: 1px solid #000000;
    border-radius: 5px;
    margin: 5px;
  }
  .item-collapse {
    font-size: 13px;
    margin: -20px;
    color: #000000;
  }

  .show {
    overflow-y: scroll !important;
    max-height: 200px !important;
    &::-webkit-scrollbar {
      width: 8px !important;
    }
    &::-webkit-scrollbar-thumb {
      background: #2759ab;
      border-radius: 4px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: #1a3e77;
      box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.2);
    }
    &::-webkit-scrollbar-thumb:active {
      background-color: #2759ab;
    }
  }

  .custom-control-label {
    font-size: 15px;
    font-weight: 600;
    padding-left: 10px;
    padding-bottom: 10px;
    padding-top: 2px;
    cursor: pointer;
  }

  /* This is the default state */
  .custom-radio .custom-control-label::before {
    border: 1px solid black;
    width: 20px;
    height: 20px;
  }

  /* This is the checked state */
  .custom-radio .custom-control-input:checked~.custom-control-label::before,
  .custom-radio .custom-control-input:checked~.custom-control-label::after {
    background-color: #f59019 !important; 
    /* this bg image SVG is just a white circle, you can replace it with any valid SVG code */
    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='3' fill='%23fff'/%3E%3C/svg%3E") !important; 
    border-radius: 100% !important;
    width: 20px;
    height: 20px;
  }

  /* active state i.e. displayed while the mouse is being pressed down */
  .custom-radio .custom-control-input:active ~ .custom-control-label::before {
    color: #fff !important;
    background-color: #2759ab !important;
  }

  /* the shadow; displayed while the element is in focus */
  .custom-radio .custom-control-input:focus ~ .custom-control-label::before {
    box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(255, 123, 255, 0.25) !important; /* pink, 25% opacity */
  }

  input[type="radio"]:checked~label {
    opacity: 1 !important;
    border: 0px solid transparent !important;
    background-color: transparent !important;
  }

  input[type="checkbox"] + label:before {
    cursor: pointer;
  	content: "";
  	width: 22px;
  	height: 22px;
  	float: left;
  	margin: 0.2em 0.5em 0 0;
    border: 2px solid #ccc;
    border-radius: 4px;
  	background: #fff;
  }
  input[type="checkbox"]:checked + label:before {
    border-color: #f59019;
    background: #f59019;
  }

  input[type="checkbox"]:checked + label:after {
    content: "";
    width: 12px;
    height: 8px;
    border: 2px solid #fff;
    float: left;
    margin-left: -1.55em;
    border-right: 0;
    border-top: 0;
    margin-top: 9px;
    transform: rotate(-50deg);
  }

  input[type="checkbox"] {
  	display: none;
  }
</style>



// WEBPACK FOOTER //
// src/views/CarFilter.vue